import React from 'react';
export default function Component() {
    return (React.createElement("div", null,
        React.createElement("p", null, "Hmm this works?")));
}
//# sourceMappingURL=HtmlWidget.js.map